<template>
	<div>
		<case-form :schema="schema" class="mt6" />
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
export default {
	components: {
		CaseForm
	},

	computed: {
		schema() {
			return [
				{
					label: "Holder",
					component: "entitySelect",
					bindTo: "case.holder",
					entity: "case.holder",
					props: {
						allowedEntityTypes: ["individual"]
					}
				},
				{
					label: "称谓",
					component: "entityField",
					entity: "case.holder",
					fieldToUpdate: "salutation",
					props: {
						updateOptions: {
							component: "select",
							props: {
								options: [
									{
										name: "Mr",
										value: "Mr"
									},
									{
										name: "Mrs",
										value: "Mrs"
									},
									{
										name: "Miss",
										value: "Miss"
									},
									{
										name: "Other",
										value: "Other"
									}
								]
							}
						}
					}
				},
				{
					label: "其他称谓",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderotherTitlesCN`,
					props: {
						suggest: {
							typeIncludes: `otherTitlesCN`
						},
						createOptions: {
							type: `otherTitlesCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "后缀名",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holdersuffixCN`,
					props: {
						suggest: {
							typeIncludes: `suffixCN`
						},
						createOptions: {
							type: `suffixCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "请问是否有曾用名，婚前姓氏或别名?",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderhasFormerNameOrAliasCN`,
					props: {
						suggest: {
							typeIncludes: `hasFormerNameOrAliasCN`
						},
						createOptions: {
							type: `hasFormerNameOrAliasCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "如果答“是”，请在下方写出该姓名",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderformerNameOrAliasCN`,
					props: {
						suggest: {
							typeIncludes: `formerNameOrAliasCN`
						},
						createOptions: {
							type: `formerNameOrAliasCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "出生日期",
					component: "entityField",
					entity: "case.holder",
					fieldToUpdate: "dateOfBirth",
					props: {
						updateOptions: {
							component: "date"
						}
					}
				},
				{
					label: "出生城市",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holdercityOfBirthCN`,
					props: {
						suggest: {
							typeIncludes: `cityOfBirthCN`
						},
						createOptions: {
							type: `cityOfBirthCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "出生国家",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holdercountryOfBirthCN`,
					props: {
						suggest: {
							typeIncludes: `countryOfBirthCN`
						},
						createOptions: {
							type: `countryOfBirthCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "国籍所在国",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holdercountriesOfCitizenshipCN`,
					props: {
						suggest: {
							typeIncludes: `countriesOfCitizenshipCN`
						},
						createOptions: {
							type: `countriesOfCitizenshipCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "地址",
					component: "entityAddress",
					entity: "case.holder",
					relation: "case.holder.addresses",
					bindTo: "case.facts.holderpermanentReisdentAddressCN",
					props: {
						suggest: {
							typeIncludes: "permanentReisdentAddressCN"
						},
						createOptions: {
							type: "permanentReisdentAddressCN"
						}
					}
				},
				{
					label: "邮寄地址（如果与上述地址不同）",
					component: "entityAddress",
					entity: "case.holder",
					relation: "case.holder.addresses",
					bindTo: "case.facts.holdermailingAddressCN",
					props: {
						suggest: {
							typeIncludes: "mailingAddressCN"
						},
						createOptions: {
							type: "mailingAddressCN"
						}
					}
				}
			]
		}
	}
}
</script>
